<template>
  <video-modal
    ref="teamInboxTutorialComponent"
    has-activator-button
    :should-show-in-first-visit="true"
    class="pl-2"
    cookie-name="ring-group-team-inbox"
    title="Explore Aloware Team Inboxes"
    video-url="https://www.loom.com/embed/57c6edbbdfdb4c7aa3ca3f31a4c463fc?sid=65c7a1b1-89dc-4bb2-a682-4e7f7947c5a4"
  />
</template>
<script>
import VideoModal from '../video-modal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'ring-group-teaminbox-tutorial-video',
  components: { VideoModal },
  methods: {
    ...mapActions('teamInbox', [
      'setTeamInboxTutorialComponent'
    ])
  },
  mounted () {
    this.setTeamInboxTutorialComponent(this.$refs.teamInboxTutorialComponent)
  }
}
</script>
